/**
 * Vape Expert Chat Widget
 * Integrates with n8n workflows for AI chat, order tracking, and contact support
 *
 * n8n Webhooks:
 * - vape-expert: Main chat AI
 * - vape-track-order: Order tracking
 * - vape-contact-support: Contact form submission
 */
(function () {
  const CHAT_WEBHOOK_URL    = "https://n8n.srv1095223.hstgr.cloud/webhook/vape-expert";
  const TRACK_WEBHOOK_URL   = "https://n8n.srv1095223.hstgr.cloud/webhook/vape-track-order";
  const CONTACT_WEBHOOK_URL = "https://n8n.srv1095223.hstgr.cloud/webhook/vape-contact-support";

  // ---------- SESSION & PERSISTENCE ----------
  function getUserId() {
    const key = "vapeExpertUserId";
    let id = localStorage.getItem(key);
    if (!id) {
      id = "web-" + Math.random().toString(36).substring(2) + Date.now();
      localStorage.setItem(key, id);
    }
    return id;
  }

  // Save chat state to sessionStorage
  function saveChatState() {
    const messages = [];
    const messageElements = document.querySelectorAll('.vape-msg');
    messageElements.forEach(el => {
      messages.push({
        text: el.textContent,
        from: el.classList.contains('vape-msg-user') ? 'user' : 'bot'
      });
    });
    sessionStorage.setItem('vapeExpertChatMessages', JSON.stringify(messages));
    sessionStorage.setItem('vapeExpertChatOpen', isOpen.toString());
  }

  // Restore chat state from sessionStorage
  function restoreChatState() {
    const savedMessages = sessionStorage.getItem('vapeExpertChatMessages');
    const wasOpen = sessionStorage.getItem('vapeExpertChatOpen') === 'true';

    if (savedMessages) {
      const messages = JSON.parse(savedMessages);
      const messagesEl = document.querySelector('.vape-chat-messages');
      if (messagesEl) {
        messages.forEach(msg => {
          const div = document.createElement("div");
          div.className = "vape-msg " + (msg.from === "user" ? "vape-msg-user" : "vape-msg-bot");
          div.textContent = msg.text;
          messagesEl.appendChild(div);
        });
        messagesEl.dataset.welcomed = "1";
        scrollToBottom();
      }
    }

    if (wasOpen) {
      setTimeout(() => openChat(), 500);
    }
  }

  // ---------- STARLITE THEME CART INTEGRATION ----------
  async function addToCartWithTheme(variantId, quantity = 1, button) {
    try {
      // Create a temporary form that mimics the product form
      const form = document.createElement('form');
      form.innerHTML = `
        <input type="hidden" name="id" value="${variantId}">
        <input type="hidden" name="quantity" value="${quantity}">
      `;

      // Get the cart drawer element
      const cartDrawer = document.querySelector("#ajax-cart-drawer[data-side-drawer]");

      // Create a temporary parent wrapper for the form
      const formParent = document.createElement('div');
      formParent.setAttribute('data-product-wrapper', 'true');
      formParent.appendChild(form);
      document.body.appendChild(formParent);

      // Use the theme's existing addItemtoCart function if it exists
      if (typeof addItemtoCart === 'function') {
        // Call the theme's function with the expected parameters
        addItemtoCart(form, formParent, button || document.createElement('button'), cartDrawer);

        // Clean up the temporary elements after a delay
        setTimeout(() => {
          if (formParent.parentNode) {
            formParent.parentNode.removeChild(formParent);
          }
        }, 100);

        return true;
      } else {
        // Fallback: Use direct API call and trigger cart update
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', 'ajax-cart-drawer');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const data = await response.json();

          // Manually trigger cart drawer update
          updateCartDrawer(data);

          // Show success notification
          showCartNotification(data);

          // Clean up
          if (formParent.parentNode) {
            formParent.parentNode.removeChild(formParent);
          }

          return true;
        }

        // Clean up on failure
        if (formParent.parentNode) {
          formParent.parentNode.removeChild(formParent);
        }

        return false;
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      return false;
    }
  }

  // Fallback cart update function
  async function updateCartDrawer(cartData) {
    try {
      // Get the cart drawer and body elements
      const cartDrawer = document.querySelector("#ajax-cart-drawer[data-side-drawer]");
      const cartBody = document.querySelector("[data-cart-drwaer-body]"); // Note: typo in theme selector

      if (!cartBody) {
        console.error('Cart body element not found');
        return;
      }

      // If we have sections data, update the cart content
      if (cartData.sections && cartData.sections['ajax-cart-drawer']) {
        const parser = new DOMParser();
        const updateCartHtml = parser.parseFromString(
          cartData.sections['ajax-cart-drawer'],
          'text/html'
        ).querySelector('.shopify-section');

        if (updateCartHtml) {
          // Update cart body content
          cartBody.innerHTML = updateCartHtml.innerHTML;

          // Get cart count
          let cartItemcount = 0;
          const cartWrapper = updateCartHtml.querySelector("[data-cart-wrapper]");
          if (cartWrapper) {
            cartItemcount = parseInt(cartWrapper.getAttribute("data-item-count"));
          }

          // Update cart count
          if (typeof cartCountUpdate === 'function') {
            cartCountUpdate(cartItemcount);
          }

          // Re-initialize cart functions
          if (cartItemcount > 0) {
            if (typeof getQuantityElement === 'function') {
              getQuantityElement(cartBody);
            }
            if (typeof cartNoteUpdate === 'function') {
              cartNoteUpdate();
            }
            if (typeof getCartItemRemoveElements === 'function') {
              getCartItemRemoveElements(cartDrawer);
            }
            if (typeof cartGiftWrapElement === 'function') {
              cartGiftWrapElement(cartDrawer);
            }
          }
        }
      }

      // Open the cart drawer
      if (cartDrawer) {
        setTimeout(() => {
          cartDrawer.classList.add("sidebar-visible");
          cartDrawer.style.display = "flex";
          document.querySelector("body").classList.add("no-scroll");
        }, 100);
      }

      // Play cart sound if available
      if (document.getElementById("cartAlert")) {
        document.getElementById("cartAlert").play();
      }

    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }

  function showCartNotification(product) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #10b981;
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 999999;
      font-size: 14px;
      animation: slideIn 0.3s ease;
    `;
    notification.textContent = `✓ Added ${product.title || product.product_title || 'item'} to cart`;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // ---------- FAQ DETECTION ----------
  function isFaqQuestion(text) {
    const t = (text || "").toLowerCase();

    if (
      t.includes("delivery") ||
      t.includes("shipping") ||
      t.includes("postage") ||
      t.includes("how long") && (t.includes("order") || t.includes("take")) ||
      t.includes("when will my order arrive")
    ) return true;

    if (
      t.includes("refund") ||
      t.includes("return") ||
      t.includes("exchange") ||
      t.includes("cancel my order") ||
      t.includes("cancel order")
    ) return true;

    if (
      t.includes("age") ||
      t.includes("id check") ||
      t.includes("id") && t.includes("delivery") ||
      t.includes("18+") ||
      t.includes("legal age")
    ) return true;

    if (
      t.includes("nicotine") ||
      t.includes("mg") && !t.includes("battery") ||
      t.includes("strength") && t.includes("nicotine")
    ) return true;

    if (
      t.includes("safe to vape") ||
      t.includes("safety") ||
      t.includes("device safe") ||
      t.includes("coil") ||
      t.includes("burnt taste") ||
      t.includes("leak") ||
      t.includes("leaking") ||
      t.includes("faulty") ||
      t.includes("warranty")
    ) return true;

    return false;
  }

 // ---------- STYLES ----------
  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    #vape-expert-chat-root {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 999999;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }
    .vape-chat-bubble {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
      font-size: 28px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .vape-chat-bubble:hover {
      transform: scale(1.08);
      box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5);
    }
    .vape-chat-window {
      width: 440px;
      max-height: 650px;
      background: #ffffff;
      border-radius: 16px;
      box-shadow: 0 16px 40px rgba(0,0,0,0.35);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .vape-chat-header {
      padding: 16px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 16px 16px 0 0;
    }
    .vape-chat-header-content {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .vape-chat-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid rgba(255, 255, 255, 0.3);
    }
    .vape-chat-avatar-inner {
      font-size: 24px;
    }
    .vape-chat-header-info {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .vape-chat-header-title {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .vape-ai-badge {
      background: rgba(255, 255, 255, 0.25);
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    .vape-chat-header-sub {
      font-size: 13px;
      opacity: 0.9;
    }
    .vape-chat-close {
      cursor: pointer;
      font-size: 24px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.2s ease;
      background: rgba(255, 255, 255, 0.1);
    }
    .vape-chat-close:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: rotate(90deg);
    }
    .vape-chat-welcome {
      padding: 20px 16px;
      background: #ffffff;
      border-bottom: 1px solid #e5e7eb;
    }
    .vape-chat-welcome-text {
      font-size: 15px;
      color: #374151;
      line-height: 1.5;
      font-weight: 500;
    }
    .vape-chat-quick-actions {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      padding: 16px;
      background: #f9fafb;
      border-bottom: 1px solid #e5e7eb;
    }
    .vape-quick-btn {
      border-radius: 12px;
      border: 1.5px solid #e5e7eb;
      background: #ffffff;
      font-size: 13px;
      font-weight: 500;
      padding: 12px 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      white-space: nowrap;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      color: #374151;
    }
    .vape-quick-btn:hover {
      background: #f9fafb;
      border-color: #667eea;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    }
    .vape-quick-btn:active {
      transform: translateY(0);
    }
    .vape-quick-btn span {
      font-size: 18px;
    }
    .vape-chat-messages {
      flex: 1;
      padding: 20px 16px;
      overflow-y: auto;
      background: #ffffff;
      font-size: 14px;
    }
    .vape-msg {
      margin-bottom: 12px;
      max-width: 75%;
      line-height: 1.5;
      padding: 12px 16px;
      border-radius: 18px;
      word-wrap: break-word;
      white-space: pre-wrap;
      animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .vape-msg-user {
      margin-left: auto;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      border-bottom-right-radius: 4px;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
    }
    .vape-msg-bot {
      margin-right: auto;
      background: #f3f4f6;
      color: #1f2937;
      border-bottom-left-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    }
    .vape-chat-input-wrap {
      padding: 16px;
      border-top: 1px solid #e5e7eb;
      display: flex;
      gap: 8px;
      background: #fff;
      align-items: center;
    }
    .vape-chat-input {
      flex: 1;
      font-size: 14px;
      padding: 12px 16px;
      border-radius: 24px;
      border: 1.5px solid #e5e7eb;
      outline: none;
      transition: all 0.2s ease;
      background: #f9fafb;
    }
    .vape-chat-input:focus {
      border-color: #667eea;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
    .vape-chat-send {
      border-radius: 50%;
      border: none;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
    }
    .vape-chat-send:hover:not(:disabled) {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }
    .vape-chat-send:active:not(:disabled) {
      transform: scale(0.95);
    }
    .vape-chat-send:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    .vape-chat-typing {
      font-size: 13px;
      color: #6b7280;
      padding: 0 16px 12px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .vape-typing-indicator {
      display: inline-flex;
      gap: 4px;
      align-items: center;
    }
    .vape-typing-indicator span {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #667eea;
      animation: typingBounce 1.4s infinite ease-in-out;
    }
    .vape-typing-indicator span:nth-child(1) {
      animation-delay: -0.32s;
    }
    .vape-typing-indicator span:nth-child(2) {
      animation-delay: -0.16s;
    }
    @keyframes typingBounce {
      0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.5;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }
    .vape-product-list {
      margin: 12px 0 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .vape-product-card {
      display: flex;
      gap: 12px;
      background: #ffffff;
      border-radius: 12px;
      padding: 12px;
      border: 1.5px solid #e5e7eb;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .vape-product-card:hover {
      border-color: #d1d5db;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }
    .vape-product-image-wrap {
      flex: 0 0 64px;
      height: 64px;
      border-radius: 10px;
      overflow: hidden;
      background: #f9fafb;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e5e7eb;
    }
    .vape-product-image-wrap img {
      max-width: 100%;
      max-height: 100%;
      display: block;
      object-fit: cover;
    }
    .vape-product-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 6px;
      justify-content: center;
    }
    .vape-product-title {
      font-size: 13px;
      font-weight: 600;
      color: #1f2937;
      line-height: 1.3;
    }
    .vape-product-price {
      font-size: 14px;
      font-weight: 700;
      color: #667eea;
    }
    .vape-product-actions {
      display: flex;
      gap: 8px;
      margin-top: 4px;
    }
    .vape-product-btn {
      border-radius: 20px;
      border: none;
      font-size: 12px;
      font-weight: 500;
      padding: 8px 14px;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .vape-product-btn-primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      box-shadow: 0 2px 6px rgba(102, 126, 234, 0.25);
    }
    .vape-product-btn-primary:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 10px rgba(102, 126, 234, 0.35);
    }
    .vape-product-btn-secondary {
      background: #f3f4f6;
      color: #374151;
      border: 1px solid #e5e7eb;
    }
    .vape-product-btn-secondary:hover {
      background: #e5e7eb;
      border-color: #d1d5db;
    }
    .vape-product-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none !important;
    }
    .vape-cart-actions {
      display: flex;
      gap: 6px;
      margin: 6px 0 10px;
      flex-wrap: wrap;
    }
    .vape-quick-add-btn {
      background: #111827;
      color: white;
      border: none;
      border-radius: 999px;
      padding: 6px 12px;
      font-size: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;
    }
    .vape-quick-add-btn:hover {
      background: #1f2937;
      transform: scale(1.05);
    }
    .vape-quick-add-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: scale(1);
    }
    .vape-faq-chip-row {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin: 6px 0 10px;
    }
    .vape-faq-chip {
      border-radius: 999px;
      border: 1px solid #d1d5db;
      background: #ffffff;
      padding: 4px 8px;
      font-size: 11px;
      cursor: pointer;
      color: #111827;
      transition: all 0.2s ease;
    }
    .vape-faq-chip:hover {
      background: #f3f4f6;
      border-color: #111827;
    }
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
      20%, 40%, 60%, 80% { transform: translateX(2px); }
    }
    .shake {
      animation: shake 0.7s ease;
    }

    /* ===== MOBILE FIXES FOR ADD TO CART BUTTON ===== */
    @media (max-width: 768px) {
      /* Fix chat window for mobile */
      .vape-chat-window {
        width: calc(100vw - 20px);
        max-width: 440px;
        max-height: 80vh;
      }

      /* Ensure product cards display properly */
      .vape-product-card {
        display: flex !important;
        min-height: 70px;
        overflow: visible !important;
      }

      /* Fix product info layout */
      .vape-product-info {
        flex: 1;
        min-width: 0;
        overflow: visible !important;
      }

      /* CRITICAL FIX: Force product actions and buttons to be visible */
      .vape-product-actions {
        display: flex !important;
        gap: 6px !important;
        margin-top: 4px !important;
        flex-wrap: wrap !important;
        visibility: visible !important;
        opacity: 1 !important;
        min-height: 30px !important;
        overflow: visible !important;
      }

      /* Force Add to Cart button to be visible on mobile */
      .vape-product-btn {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        min-width: 80px !important;
        min-height: 32px !important;
        padding: 8px 12px !important;
        font-size: 12px !important;
        position: relative !important;
        z-index: 10 !important;
        -webkit-tap-highlight-color: rgba(0,0,0,0.1);
        touch-action: manipulation;
        pointer-events: auto !important;
        cursor: pointer !important;
      }

      /* Specific fix for primary button (Add to Cart) */
      .vape-product-btn-primary {
        display: inline-block !important;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        color: #fff !important;
        border: none !important;
        visibility: visible !important;
        opacity: 1 !important;
        z-index: 999 !important;
        pointer-events: auto !important;
        cursor: pointer !important;
        font-weight: 600 !important;
        box-shadow: 0 2px 6px rgba(102, 126, 234, 0.25) !important;
      }

      /* Make product image smaller on mobile to give more room */
      .vape-product-image-wrap {
        flex: 0 0 45px;
        height: 45px;
      }

      /* Adjust text sizes for mobile */
      .vape-product-title {
        font-size: 11px;
        line-height: 1.3;
      }

      .vape-product-price {
        font-size: 11px;
      }

      /* Ensure scrolling works properly */
      .vape-chat-messages {
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      /* Fix product list container */
      .vape-product-list {
        overflow: visible !important;
      }
    }

    /* iOS-specific fixes */
    @supports (-webkit-touch-callout: none) {
      .vape-product-btn {
        -webkit-appearance: none;
        cursor: pointer;
      }

      .vape-product-btn-primary {
        -webkit-appearance: none;
      }

      .vape-product-actions {
        -webkit-transform: translate3d(0,0,0);
      }
    }
  `;
  document.head.appendChild(style);

  // ---------- DOM ----------
  const root = document.getElementById("vape-expert-chat-root");
  if (!root) return;

  let isOpen = false;
  let mode = null;
  let trackStep = 0;
  let trackData = { orderNumber: null, postcode: null };

  const bubble = document.createElement("div");
  bubble.className = "vape-chat-bubble";
  bubble.innerHTML = "💬";

  const windowEl = document.createElement("div");
  windowEl.className = "vape-chat-window";
  windowEl.style.display = "none";

  windowEl.innerHTML = `
    <div class="vape-chat-header">
      <div class="vape-chat-header-content">
        <div class="vape-chat-avatar">
          <div class="vape-chat-avatar-inner">💨</div>
        </div>
        <div class="vape-chat-header-info">
          <div class="vape-chat-header-title">
            Vape Expert <span class="vape-ai-badge">AI</span>
          </div>
          <div class="vape-chat-header-sub">VapeSaloon</div>
        </div>
      </div>
      <div class="vape-chat-close">&times;</div>
    </div>
    <div class="vape-chat-welcome">
      <div class="vape-chat-welcome-text">Hey! I'm your Vape Expert. How can I help you?</div>
    </div>
    <div class="vape-chat-quick-actions">
      <button class="vape-quick-btn" data-action="explore">
        <span>🛍️</span> Explore products
      </button>
      <button class="vape-quick-btn" data-action="track">
        <span>📦</span> Track order
      </button>
      <button class="vape-quick-btn" data-action="faq">
        <span>❓</span> General enquiries
      </button>
      <button class="vape-quick-btn" data-action="contact">
        <span>💬</span> Contact support
      </button>
    </div>
    <div class="vape-chat-messages"></div>
    <div class="vape-chat-typing" style="display:none;">
      <div class="vape-typing-indicator">
        <span></span><span></span><span></span>
      </div>
      <span>Vape Expert is typing</span>
    </div>
    <div class="vape-chat-input-wrap">
      <input class="vape-chat-input" type="text" placeholder="Type here..." />
      <button class="vape-chat-send">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M15 1L7 9M15 1L10 15L7 9M15 1L1 6L7 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  root.appendChild(windowEl);
  root.appendChild(bubble);

  const closeBtn   = windowEl.querySelector(".vape-chat-close");
  const messagesEl = windowEl.querySelector(".vape-chat-messages");
  const typingEl   = windowEl.querySelector(".vape-chat-typing");
  const inputEl    = windowEl.querySelector(".vape-chat-input");
  const sendBtn    = windowEl.querySelector(".vape-chat-send");

  const exploreBtn = windowEl.querySelector('[data-action="explore"]');
  const trackBtn   = windowEl.querySelector('[data-action="track"]');
  const faqBtn     = windowEl.querySelector('[data-action="faq"]');
  const contactBtn = windowEl.querySelector('[data-action="contact"]');

  // ---------- HELPERS ----------
  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function addMessage(text, from) {
    if (!text) return;
    const div = document.createElement("div");
    div.className = "vape-msg " + (from === "user" ? "vape-msg-user" : "vape-msg-bot");
    div.textContent = text;
    messagesEl.appendChild(div);
    scrollToBottom();
    saveChatState();
  }

  function renderProducts(products) {
    if (!Array.isArray(products) || !products.length) return;

    console.log('[Vape Expert] Rendering products:', products);

    const listWrap = document.createElement("div");
    listWrap.className = "vape-product-list";

    products.forEach((p) => {
      console.log('[Vape Expert] Product:', p.title, 'VariantId:', p.variantId);
      const card = document.createElement("div");
      card.className = "vape-product-card";

      const imgWrap = document.createElement("div");
      imgWrap.className = "vape-product-image-wrap";
      if (p.image) {
        const img = document.createElement("img");
        img.src = p.image;
        img.alt = p.title || "Product";
        imgWrap.appendChild(img);
      } else {
        imgWrap.textContent = "🛍️";
      }

      const info = document.createElement("div");
      info.className = "vape-product-info";

      const titleEl = document.createElement("div");
      titleEl.className = "vape-product-title";
      titleEl.textContent = p.title || "Product";

      const priceEl = document.createElement("div");
      priceEl.className = "vape-product-price";
      if (p.price) {
        priceEl.textContent = "£" + p.price;
      }

      const actions = document.createElement("div");
      actions.className = "vape-product-actions";

      if (p.variantId) {
        const addBtn = document.createElement("button");
        addBtn.className = "vape-product-btn vape-product-btn-primary";
        addBtn.innerHTML = "🛒 Add to cart";
        addBtn.addEventListener("click", async () => {
          addBtn.disabled = true;
          addBtn.textContent = "Adding...";

          const success = await addToCartWithTheme(p.variantId, 1, addBtn);

          if (success) {
            addBtn.textContent = "✓ Added";
            setTimeout(() => {
              addBtn.innerHTML = "🛒 Add to cart";
              addBtn.disabled = false;
            }, 2000);
          } else {
            addBtn.textContent = "Failed";
            setTimeout(() => {
              addBtn.innerHTML = "🛒 Add to cart";
              addBtn.disabled = false;
            }, 2000);
          }
        });
        actions.appendChild(addBtn);
      }

      const viewBtn = document.createElement("button");
      viewBtn.className = "vape-product-btn vape-product-btn-secondary";
      viewBtn.textContent = "View details";
      viewBtn.addEventListener("click", () => {
        if (p.url) window.open(p.url, "_blank");
      });

      actions.appendChild(viewBtn);
      info.appendChild(titleEl);
      info.appendChild(priceEl);
      info.appendChild(actions);

      card.appendChild(imgWrap);
      card.appendChild(info);
      listWrap.appendChild(card);
    });

    messagesEl.appendChild(listWrap);
    scrollToBottom();
    saveChatState();
  }

  function renderQuickAddButtons(products) {
    if (!Array.isArray(products) || !products.length) return;

    const actionsWrap = document.createElement("div");
    actionsWrap.className = "vape-cart-actions";

    products.forEach((p) => {
      if (!p.variantId) return;

      const btn = document.createElement("button");
      btn.className = "vape-quick-add-btn";
      btn.innerHTML = `🛒 Add ${p.title}`;

      btn.addEventListener("click", async () => {
        btn.disabled = true;
        btn.textContent = "Adding...";

        const success = await addToCartWithTheme(p.variantId, 1, btn);

        if (success) {
          btn.innerHTML = `✓ Added ${p.title}`;
          addMessage(`Great! I've added ${p.title} to your cart.`, "bot");
          setTimeout(() => {
            btn.innerHTML = `🛒 Add ${p.title}`;
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = "Failed - Try again";
          setTimeout(() => {
            btn.innerHTML = `🛒 Add ${p.title}`;
            btn.disabled = false;
          }, 2000);
        }
      });

      actionsWrap.appendChild(btn);
    });

    messagesEl.appendChild(actionsWrap);
    scrollToBottom();
    saveChatState();
  }

  function setTyping(visible) {
    typingEl.style.display = visible ? "block" : "none";
  }

  function showFaqChips() {
    const row = document.createElement("div");
    row.className = "vape-faq-chip-row";

    const chips = [
      {
        label: "Delivery times",
        prompt: "What are your delivery times and how long does delivery take?"
      },
      {
        label: "Returns & refunds",
        prompt: "What is your refunds and returns policy?"
      },
      {
        label: "Age limit / ID checks",
        prompt: "What age do I need to be and do you do ID checks?"
      },
      {
        label: "Nicotine strength help",
        prompt: "Can you help me choose the right nicotine strength?"
      },
      {
        label: "Device safety & coils",
        prompt: "Can you help with device safety, coil life and burnt taste issues?"
      }
    ];

    chips.forEach(chip => {
      const btn = document.createElement("button");
      btn.className = "vape-faq-chip";
      btn.textContent = chip.label;
      btn.addEventListener("click", () => {
        // FIXED: Clear previous state before setting FAQ mode
        trackStep = 0;
        trackData = { orderNumber: null, postcode: null };

        addMessage(chip.label, "user");
        mode = "faq";
        sendToChatAgent(chip.prompt);
      });
      row.appendChild(btn);
    });

    messagesEl.appendChild(row);
    scrollToBottom();
  }

  // ---------- TRACK ORDER FLOW ----------
  function startTrackOrderFlow() {
    mode = "track_order";
    trackStep = 1;
    trackData = { orderNumber: null, postcode: null };

    addMessage(
      "Sure, I can help track your order. Please enter your order number (for example: 2150 or #2150).",
      "bot"
    );
  }

  async function handleTrackOrderInput(userText) {
    if (trackStep === 1) {
      trackData.orderNumber = userText.trim();
      trackStep = 2;
      addMessage(
        "Great, now please enter the postcode you used at checkout (for example: PR8 1AA).",
        "bot"
      );
      return;
    }

    if (trackStep === 2) {
      trackData.postcode = userText.trim();
      trackStep = 0;
      mode = null;

      addMessage("Thanks, let me check the status of your order…", "bot");
      await requestOrderTracking(trackData.orderNumber, trackData.postcode);
    }
  }

  async function requestOrderTracking(orderNumber, postcode) {
    try {
      setTyping(true);

      const payload = {
        userId: getUserId(),
        orderNumber,
        postcode
      };

      const res = await fetch(TRACK_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const raw = await res.text();
      console.log("Vape Expert track raw:", raw);

      let reply = "Sorry, I couldn't find that order. Please double-check the order number and postcode.";
      if (raw) {
        try {
          const data = JSON.parse(raw);
          if (data && data.reply) reply = data.reply;
        } catch (e) {
          reply = raw;
        }
      }

      addMessage(reply, "bot");
    } catch (err) {
      console.error("Vape Expert track error:", err);
      addMessage("Something went wrong while checking your order. Please try again in a moment.", "bot");
    } finally {
      setTyping(false);
    }
  }

  // ---------- CONTACT SUPPORT FLOW ----------
  let contactStep = 0;
  let contactData = { name: null, email: null, message: null };

  function startContactSupportFlow() {
    mode = "contact_support";
    contactStep = 1;
    contactData = { name: null, email: null, message: null };

    addMessage(
      "I'd be happy to put you in touch with our team! First, what's your name?",
      "bot"
    );
  }

  async function handleContactSupportInput(userText) {
    if (contactStep === 1) {
      contactData.name = userText.trim();
      contactStep = 2;
      addMessage(
        `Thanks ${contactData.name}! What's the best email address to reach you?`,
        "bot"
      );
      return;
    }

    if (contactStep === 2) {
      contactData.email = userText.trim();
      contactStep = 3;
      addMessage(
        "Perfect! What would you like help with?",
        "bot"
      );
      return;
    }

    if (contactStep === 3) {
      contactData.message = userText.trim();
      contactStep = 0;
      mode = null;

      addMessage("Thanks! Sending your message to our team now...", "bot");
      await sendContactMessage(contactData.name, contactData.email, contactData.message);
    }
  }

  async function sendContactMessage(name, email, message) {
    try {
      setTyping(true);

      const payload = {
        userId: getUserId(),
        name,
        email,
        message,
        timestamp: new Date().toISOString()
      };

      const res = await fetch(CONTACT_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        addMessage(
          "✓ Message sent! Our team will get back to you via email shortly. Is there anything else I can help you with?",
          "bot"
        );
      } else {
        addMessage(
          "Sorry, there was an issue sending your message. Please try emailing us directly at orders@vapesaloon.co.uk",
          "bot"
        );
      }
    } catch (err) {
      console.error("Contact support error:", err);
      addMessage(
        "Sorry, there was an issue sending your message. Please try emailing us directly at orders@vapesaloon.co.uk",
        "bot"
      );
    } finally {
      setTyping(false);
    }
  }

  // ---------- NORMAL AI MESSAGE FLOW ----------
  // ---------- FIXED NORMAL AI MESSAGE FLOW ----------
  async function sendToChatAgent(text) {
    const userId = getUserId();
    const payload = {
      userId,
      channel: "webchat",
      message: text
    };

    setTyping(true);
    sendBtn.disabled = true;

    try {
      const res = await fetch(CHAT_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const raw = await res.text();
      console.log("Vape Expert raw response:", raw);

      let reply = "Sorry, I couldn't get a reply just now.";
      let products = [];
      let quickAddProducts = [];
      let followUp = null;

      if (raw) {
        try {
          // Try to parse as JSON first
          const data = JSON.parse(raw);

          reply = data.reply || data.output || data.result || reply;

          // Clean "shorten reply" text from the reply and variations
          if (typeof reply === 'string') {
            reply = reply.replace(/\s*shorten(?:ed)?\s+reply\s*/gi, '').trim();
            reply = reply.replace(/\(reply\s+shortened.*?\)/gi, '').trim();
          }

          if (Array.isArray(data.products)) {
            products = data.products;
          }

          if (Array.isArray(data.quickAddProducts)) {
            quickAddProducts = data.quickAddProducts;
          }

          if (typeof data.followUp === "string" && data.followUp) {
            followUp = data.followUp;
            // Clean "shorten reply" from followUp too
            followUp = followUp.replace(/\s*shorten(?:ed)?\s+reply\s*/gi, '').trim();
            followUp = followUp.replace(/\(reply\s+shortened.*?\)/gi, '').trim();
          }

        } catch (e) {
          console.error("Failed to parse JSON, attempting to clean raw text:", e);

          // FIXED: Clean up malformed response that contains JSON-like text
          // Remove any JSON-like artifacts from the raw text
          let cleanedReply = raw;

          // Remove "shorten reply" or "Shorten reply" text and variations
          cleanedReply = cleanedReply.replace(/\s*shorten(?:ed)?\s+reply\s*/gi, '');
          cleanedReply = cleanedReply.replace(/\(reply\s+shortened.*?\)/gi, '');

          // Remove "products: []" or "products: [...]" patterns
          cleanedReply = cleanedReply.replace(/\s*products:\s*\[.*?\]/gs, '');

          // Remove "followUp: "..." patterns
          cleanedReply = cleanedReply.replace(/\s*followUp:\s*".*?"/gs, '');
          cleanedReply = cleanedReply.replace(/\s*followUp:\s*'.*?'/gs, '');

          // Remove "output: " prefix if present
          cleanedReply = cleanedReply.replace(/^output:\s*/i, '');

          // Remove "reply: " prefix if present
          cleanedReply = cleanedReply.replace(/^reply:\s*/i, '');

          // Remove any trailing/leading quotes
          cleanedReply = cleanedReply.replace(/^["']|["']$/g, '');

          // Clean up any double spaces or extra whitespace
          cleanedReply = cleanedReply.replace(/\s+/g, ' ').trim();

          // Only use the cleaned text if it's reasonable
          if (cleanedReply && !cleanedReply.includes('{') && !cleanedReply.includes('function')) {
            reply = cleanedReply;
          }

          // Try to extract products and followUp from the raw text if they exist
          // This handles cases where n8n returns text with embedded JSON-like structure
          const productsMatch = raw.match(/products:\s*(\[.*?\])/s);
          if (productsMatch) {
            try {
              products = JSON.parse(productsMatch[1]);
            } catch (e) {
              console.log("Could not parse products from raw text");
            }
          }

          const followUpMatch = raw.match(/followUp:\s*["']([^"']+)["']/);
          if (followUpMatch) {
            followUp = followUpMatch[1];
          }
        }
      }

      // Add the main reply message (now cleaned)
      addMessage(reply, "bot");

      // Check if we're in FAQ mode
      const isFaqContext = (mode === "faq");

      // Only show products if not in FAQ mode AND products exist
      if (products && products.length && !isFaqContext) {
        renderProducts(products);
      }

      // Only show quick add buttons if not in FAQ mode AND they exist
      if (quickAddProducts && quickAddProducts.length && !isFaqContext) {
        renderQuickAddButtons(quickAddProducts);
      }

      // Only show followUp if it exists, is not empty, and not in FAQ mode
      if (followUp && followUp.trim() && !isFaqContext) {
        addMessage(followUp, "bot");
      }

    } catch (err) {
      console.error("Vape Expert error:", err);
      addMessage("Sorry, something went wrong. Please try again in a moment.", "bot");
    } finally {
      setTyping(false);
      sendBtn.disabled = false;
      inputEl.focus();

      // Reset FAQ mode after handling the response
      if (mode === "faq") {
        mode = null;
      }
    }
  }

  // ---------- INPUT HANDLER ----------
  async function sendMessage() {
    const text = (inputEl.value || "").trim();
    if (!text) return;
    inputEl.value = "";
    addMessage(text, "user");

    if (mode === "track_order") {
      await handleTrackOrderInput(text);
      return;
    }

    if (mode === "contact_support") {
      await handleContactSupportInput(text);
      return;
    }

    if (mode === "faq" || isFaqQuestion(text)) {
      mode = "faq";
      await sendToChatAgent(text);
      return;
    }

    await sendToChatAgent(text);
  }

  // ---------- QUICK ACTIONS ----------
  exploreBtn.addEventListener("click", () => {
    // Reset any previous state
    mode = null;
    trackStep = 0;
    trackData = { orderNumber: null, postcode: null };

    addMessage("🛍️ Explore products", "user");
    addMessage(
      "Great! Tell me what you're looking for – for example: 'fruity 10mg nic salts', 'starter pod kit under £30', or 'coils for Caliburn G2'.",
      "bot"
    );
  });

  trackBtn.addEventListener("click", () => {
    // Reset any previous state
    mode = null;
    trackStep = 0;
    trackData = { orderNumber: null, postcode: null };

    addMessage("📦 Track order", "user");
    startTrackOrderFlow();
  });

  faqBtn.addEventListener("click", () => {
    // FIXED: Reset previous state before setting FAQ mode
    trackStep = 0;
    trackData = { orderNumber: null, postcode: null };
    setTyping(false);

    mode = "faq";
    addMessage("❓ General enquiries", "user");
    addMessage(
      "No problem – what would you like to know? I can help with delivery times, returns & refunds, age limits/ID checks, nicotine strength, or device safety.",
      "bot"
    );
    showFaqChips();
  });

  contactBtn.addEventListener("click", () => {
    // Reset any previous state
    mode = null;
    trackStep = 0;
    trackData = { orderNumber: null, postcode: null };
    contactStep = 0;
    contactData = { name: null, email: null, message: null };
    setTyping(false);

    addMessage("💬 Contact support", "user");
    startContactSupportFlow();
  });

  // ---------- OPEN/CLOSE ----------
  function openChat() {
    isOpen = true;
    windowEl.style.display = "flex";
    inputEl.focus();

    // Don't show the old welcome message - we have a nice welcome section now
    if (!messagesEl.dataset.welcomed && messagesEl.children.length === 0) {
      messagesEl.dataset.welcomed = "1";
    }

    saveChatState();
  }

  function closeChat() {
    isOpen = false;
    windowEl.style.display = "none";
    saveChatState();
  }

  bubble.addEventListener("click", () => {
    if (isOpen) closeChat(); else openChat();
  });

  closeBtn.addEventListener("click", closeChat);
  sendBtn.addEventListener("click", sendMessage);
  inputEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  // Save and restore chat state
  window.addEventListener('beforeunload', saveChatState);
  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(restoreChatState, 100);
  });
})();
